import script from "./Icon.vue?vue&type=script&lang=ts&setup=true"
export * from "./Icon.vue?vue&type=script&lang=ts&setup=true"

import "./Icon.vue?vue&type=style&index=0&id=51e29876&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51e29876"]])

export default __exports__